import { useEffect, useCallback } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/store'
import { fetchTasksByFilters } from '../../redux/task/actions'
import { selectLoadingFetchTasks, selectErrorFetchTasks, selectTask } from '../../redux/task/selector'

export function useFetchTasks(filters: Record<string, any> = {}, refreshTrigger?: number) {
  const dispatch = useAppDispatch()
  const loading = useAppSelector(selectLoadingFetchTasks)
  const error = useAppSelector(selectErrorFetchTasks)
  const tasks = useAppSelector(selectTask)

  const fetchTasks = useCallback(async () => {
    if (loading) return // Prevent multiple simultaneous requests
    
    try {
      await dispatch(fetchTasksByFilters(filters)).unwrap()
    } catch (error) {
      console.error('Error fetching tasks:', error)
    }
  }, [dispatch, JSON.stringify(filters), loading])

  useEffect(() => {
    fetchTasks()
  }, [refreshTrigger]) // Only depend on refreshTrigger, not fetchTasks

  return { tasks, loading, error }
}
